import { useEffect } from 'react';
import { useTimeout } from './';

export function useDebounce(cb, delay, dependencies) {
  const { reset, clear } = useTimeout(cb, delay);
  useEffect(reset, [...dependencies, reset]);
  //eslint-disable-next-line
  useEffect(clear, []);
}

// USAGE
// export default function DebounceComponent() {
//   const [count, setCount] = useState(10);
//   useDebounce(() => alert(count), 1000, [count]);

//   return (
//     <div>
//       <div>{count}</div>
//       <p>This Increments by 1</p>
//       <button onClick={() => setCount((c) => c + 1)}>Increment</button>
//     </div>
//   );
// }
